export type DownloadFilters = {
  excludeContractStatuses?: string[]
}

export const DEFAULT_EXCLUDED_CONTRACT_STATUSES: string[] = []
